import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import "./index.css"; // the pager's styles, wherever it is used

/**
 * The page numbers to show (zero-based) around the current page, with gaps:
 * 0 … 3 4 5 … 76 for page 4 of 77.
 */
export function pageItems(page: number, pageCount: number): (number | "gap")[] {
  const shown = new Set(
    [0, page - 1, page, page + 1, pageCount - 1].filter(
      (p) => p >= 0 && p < pageCount
    )
  );
  const items: (number | "gap")[] = [];
  Array.from(shown)
    .sort((a, b) => a - b)
    .forEach((p, i, sorted) => {
      if (i > 0 && p - sorted[i - 1] > 1) items.push("gap");
      items.push(p);
    });
  return items;
}

/**
 * Previous, the page numbers and next: borderless controls of one size, the
 * current page in the panel's soft blue tint.
 */
export default function Pager({
  page,
  pageCount,
  onPage,
  disabled = false,
}: {
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
  disabled?: boolean;
}) {
  return (
    <nav className="people-panel__pager" aria-label="Pages">
      <button
        type="button"
        className="people-panel__page"
        disabled={disabled || page === 0}
        aria-label="Previous page"
        onClick={() => onPage(page - 1)}
      >
        <ChevronLeftIcon />
      </button>
      {pageItems(page, pageCount).map((item, i) =>
        item === "gap" ? (
          <span key={`gap-${i}`} className="people-panel__page-gap">
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            className="people-panel__page"
            disabled={disabled}
            aria-label={`Page ${item + 1}`}
            aria-current={item === page ? "page" : undefined}
            onClick={() => onPage(item)}
          >
            {item + 1}
          </button>
        )
      )}
      <button
        type="button"
        className="people-panel__page"
        disabled={disabled || page >= pageCount - 1}
        aria-label="Next page"
        onClick={() => onPage(page + 1)}
      >
        <ChevronRightIcon />
      </button>
    </nav>
  );
}
